/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { Rotation } from './InteractiveComponents';
export const metadata = {
  demo: Rotation,
  title: 'Rotation'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Objects also have a `}<inlineCode parentName="p">{`rotation`}</inlineCode>{`, which is a `}<a parentName="p" {...{
        "href": "https://threejs.org/docs/#api/en/math/Euler"
      }}>{`THREE.Euler`}</a>{` that you can use to rotate an object.`}</p>
    <p>{`The class is very similar to `}<inlineCode parentName="p">{`THREE.Vector3`}</inlineCode>{`, but values are in radians.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
